// ✅ SignalR Hub Method Names
export const SIGNALR_METHODS = {
    // Client-side methods (what backend calls)
    STREAM_STARTED: "StreamStarted",
    RECEIVE_REFERENCES: "ReceiveReferences", 
    RECEIVE_TOKEN: "ReceiveToken",
    COMPLETE: "Complete",
    STREAM_CANCELLED: "StreamCancelled",
    
    // Server-side methods (what frontend calls)
    CHAT_WITH_RAG: "ChatWithRAG",
    STOP_CHAT_STREAM: "StopChatStream",
} as const;

// ✅ Chat UI Constants
export const CHAT_UI = {
    WINDOW_WIDTH: 360,
    WINDOW_HEIGHT: 520,
    MESSAGE_MAX_WIDTH: '80%',
    INPUT_HEIGHT: 50,
    INPUT_MAX_HEIGHT: 110,
    HEADER_HEIGHT: 50,
    BUTTON_SIZE: 40,
    CHAT_BUTTON_SIZE: 50,
    STREAM_TOKEN_INTERVAL: 30,
    MULTI_LINE_THRESHOLD: 26,
} as const;

// ✅ Timeout Constants
export const TIMEOUTS = {
    SERVER_TIMEOUT: 180000, // 3 minutes
    KEEP_ALIVE_INTERVAL: 15000, // 15 seconds
} as const;

// ✅ Colors
export const COLORS = {
    PRIMARY: '#007BC0',
    PRIMARY_HOVER: '#0066a3',
    DANGER: '#dc3545',
    DANGER_HOVER: '#c82333',
    SUCCESS: '#28a745',
    BACKGROUND_LIGHT: '#f3f2f1',
    BACKGROUND_GRAY: '#f9f9f9',
    TEXT_GRAY: '#666',
    BORDER_GRAY: '#ddd',
    REFERENCE_BG: '#f8f9fa',
    REFERENCE_BORDER: '#e9ecef',
} as const;

// ✅ Messages
export const MESSAGES = {
    WELCOME: "Good morning! Welcome to FEBER AI Assistant. What scientific knowledge are you looking for?",
    CANCELLED_SUFFIX: `\n\n<strong>\n\n*[Response cancelled by user]*</strong>`,
    GENERATING: "Generating response...",
    PLACEHOLDER: "Type a message...",
    REFERENCES_TITLE: "📚 References:",
} as const;

// ✅ Icon Names
export const ICONS = {
    SEND: "Send",
    STOP: "CircleStop",
    CANCEL: "Cancel",
    CLOSE: "Cancel",
    MORE:"More"
} as const;